import script from "./WizardSettingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardSettingStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardSettingStep.vue?vue&type=style&index=0&id=916ec384&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-916ec384"]])

export default __exports__